<input
  type="text"
  maxlength="11"
  class="form-control"
  autocomplete="ssn-no-autofill"
  [ngModel]="isHidden ? formatMaskedSsn(ssn) : formatSSN(ssn)"
  (ngModelChange)="ssn = $event"
  (input)="onInput($event)"
  (blur)="onBlur()"
  (focus)="onFocus()"
  [class]="formHelper.getValidIndicator(control)"
  [id]="control.element.id"
/>
